import store from "@/store/index";

export function CheckMerchantPackage(validPackageList: Array<number>) {
  const currentMerchant = store.getters["Merchant/getMerchantDetail"];
  const packageId = currentMerchant.peakPackage;
  if (validPackageList.includes(packageId)) {
    return true;
  }
  return false;
}
